import { get } from 'lodash';
import { loadState } from '../LocalStorage';

const { loggedIn, user, token, modules } = get(loadState(), "auth") || {};

export default {

    companies: {
        companiesList: []
    },
    users: {
        usersList: []
    },
    patient:{
        patientList:[]
    },
    modules: {       
        modulesList: [],
        userModulesList: []
    },

    globalError: {

    },
    auth: {
        token: token || "",
        loggedIn: loggedIn || false,
        modules: modules || [],
        user: {
            ...user
        },
    },
    global: {
        isLoading: false
    },
    theme: "dark-theme",
    companyDefaults: {
        
    }

}